<template>
    <b-card-text>
        <yes_no
            key="PAY_CACHE"
            title="PAY_CACHE"
            @input="on_change_value"
            v-model="item.pay_cache"
        >
        </yes_no>

        <yes_no
            key="PAY_ONLINE"
            title="PAY_ONLINE"
            @input="on_change_value"
            v-model="item.pay_online"
        >
        </yes_no>

        <yes_no
            key="PAY_TERMINAL"
            title="PAY_TERMINAL"
            @input="on_change_value"
            v-model="item.pay_terminal"
        >
        </yes_no>

    </b-card-text>
</template>

<script>
import yes_no from "../../../../sys/radio/yes_no.vue";

export default {
    name: "pwa_qr_payment_type",
    components: {yes_no},
    props : {
        location : {
            type : Object
        }
    },

    methods : {
        on_change_value( ) {

        }
    }

}
</script>



<style scoped>

</style>
